import PropTypes from "prop-types";
import cn from "classnames";
import { CaretLeft, CaretRight } from "@icons";

export function SliderControls({
  active,
  length,
  handleMediaSelect,
  showNumbers = "true",
  legendLabel = "",
  classNames = "",
  handleNext = () => {
    const nextIndex = (active + 1) % length;
    handleMediaSelect(nextIndex);
  },
  handlePrevious = () => {
    const prevIndex = (active - 1 + length) % length;
    handleMediaSelect(prevIndex);
  },
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-center gap-4 p-2 bg-white rounded-pill",
        classNames
      )}
    >
      <button
        className="disabled:opacity-50"
        onClick={handlePrevious}
        disabled={active === 0}
        aria-label="previous slide"
        type="button"
      >
        <CaretLeft className="text-2xl text-blue" />
      </button>
      <div className="text-sm font-semibold text-center text-black-300 w-14">
        {legendLabel} {showNumbers ? `${active + 1} / ${length}` : ""}
      </div>
      <button
        className="disabled:opacity-50"
        onClick={handleNext}
        disabled={active === length - 1}
        aria-label="next slide"
        type="button"
      >
        <CaretRight className="text-2xl text-blue" />
      </button>
    </div>
  );
}

SliderControls.propTypes = {
  classNames: PropTypes.string,
  showNumbers: PropTypes.bool,
  active: PropTypes.number.isRequired,
  length: PropTypes.number.isRequired,
  handleMediaSelect: PropTypes.func.isRequired,
  handleNext: PropTypes.func,
  handlePrevious: PropTypes.func,
  legendLabel: PropTypes.string,
};
